import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import "./css/authstyles.css";

const API_URL =
  import.meta.env.VITE_LYRAZONE_BASE_URL || "http://localhost:5000/api";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setErrorMessage(""); // Reset message before making the request
    try {
      const response = await axios.post(`${API_URL}/forgot-password`, {
        email,
      });
      // alert(response.data.message);
      setErrorMessage(response.data.message);
      setIsModalOpen(true);
    } catch (error: any) {
      setErrorMessage(error.response?.data?.message || "Something went wrong!");
      setIsModalOpen(true);
    }
  };

  const closeModal = (path: string) => {
    setIsModalOpen(false);
    setErrorMessage("");
    navigate(path);
  };

  return (
    <div className="auth-container">
      <h2>Forgot Password</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="Enter your email"
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button type="submit">Send Reset Link</button>
      </form>
      {/* Error Modal */}
      {isModalOpen && (
        <div className="auth-modal-overlay">
          <div className="auth-modal">
            {errorMessage && (
              <>
                <img
                  src="/images/oops-icon.png"
                  alt="Oops"
                  className="oops-icon"
                />
                <div className="error-message">{errorMessage}</div>
              </>
            )}

            <div className="modal-buttons">
              <button onClick={() => closeModal("/signin")} className="ok-btn">
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ForgotPassword;
